// // // api的baseUrl测试环境
// export const baseURL = {
//   production: 'https://test-ijournal-service.topeditsci.com',
//   lan: 'http://journal-service.youpin-k8s.net',
//   development: 'https://test-ijournal-service.topeditsci.com http://192.168.1.17:9911'
// }[process.env.NODE_ENV]

// // cookie 域
// export const cookieDomain = {
//   'production': 'topeditsci.com',
//   'lan': 'youpin-k8s.net',
//   'development': 'localhost'
// }[process.env.NODE_ENV]

// api的baseUrl生产环境
export const baseURL = {
  production2: 'https://ijournal-service.topeditsci.com',
  lan: 'http://journal-service.youpin-k8s.net',
  production: 'https://test-ijournal-service.topeditsci.com'
}[process.env.NODE_ENV]

// 因为无法访问第三方服务器，原生产环境地址ijournal-service被弃用
// php后端生产环境地址：https://test-ijournal-service.topeditsci.com
// php后端测试环境地址：https://testdb-ijournal-service.topeditsci.com

// api的baseUrl
export const baseURL2 = {
  production2: 'https://ijournal-web.topeditsci.com:8460',
  lan: 'https://ijournal-web.topeditsci.com:8460',
  production: 'https://ijournal-web-test.topeditsci.com:8460'
}[process.env.NODE_ENV]

// api的baseUrl
export const baseURL3 = {
  production2: 'https://platform-web.topeditsci.com:8440',
  lan: 'https://platform-web.topeditsci.com:8440',
  production: 'https://platform-web-test.topeditsci.com:8440'
}[process.env.NODE_ENV]

// cookie 域
export const cookieDomain = {
  'production': 'topeditsci.com',
  'lan': 'youpin-k8s.net',
  'development': 'localhost'
}[process.env.NODE_ENV]


// WEBPACK FOOTER //
// ./src/config/index.js